export default "__VITE_ASSET__DccqbB$P__"